module.exports = __webpack_public_path__ + "index_pc/media/under_05_sec.ac024543.aac";